import React, { FC } from "react"
import { graphql } from "gatsby"
import Markdown from "markdown-to-jsx"

import {
  ContentTableScrollerDIV,
  ContentTableTABLE,
  ContentTableWrapperDIV,
} from "./ContentTable.styles"
import { TableFragmentFragment } from "@graphqlTypes"
import ContentBreakout from "../ContentBreakout/ContentBreakout"

const ContentTable: FC<TableFragmentFragment> = ({
  tableData,
}) => (
  <ContentBreakout>
    <ContentTableWrapperDIV>
      <ContentTableScrollerDIV>
        <ContentTableTABLE>
          {tableData?.headings && tableData.headings.length > 0 && (
            <thead>
              <tr>
                {tableData.headings.map(cell => cell ? (
                  <th 
                    key={cell.key}
                  >
                    {cell.content}
                  </th>
                ) : null)}
              </tr>
            </thead>
          )}
          <tbody>
            {tableData?.rows && tableData?.rows.map((columns, i) => columns ? (
              <tr key={i + 1}>
                {columns.map(cell => cell ? (
                  <td
                    key={cell.key}
                  >
                    <Markdown options={{ forceBlock: true }}>{cell.content}</Markdown>
                  </td>
                ) : null)}
              </tr>
            ) : null)}
          </tbody>
        </ContentTableTABLE>
      </ContentTableScrollerDIV>
    </ContentTableWrapperDIV>
  </ContentBreakout>
)

export const TableFragment = graphql`
fragment TableFragment on ContentfulContentBlockTable {
  contentful_id
  tableData {
    headings {
      content
      key
    }
    rows {
      content
      key
    }
  }
}
`

export default ContentTable
